/**
 * Browser side of the operator session (spec 140 REQ-140-004, ADR-033). The
 * session cookie is HttpOnly; the readable CSRF cookie is echoed as
 * `X-CSRF-Token` on every state-changing request. Over https the API names it
 * `__Host-ss_operator_csrf`, on a plain-http development origin `ss_operator_csrf`.
 */
export const CSRF_COOKIE = 'ss_operator_csrf';
export const HOST_CSRF_COOKIE = `__Host-${CSRF_COOKIE}`;
export const CSRF_HEADER = 'X-CSRF-Token';

function readCookie(name: string): string | undefined {
  for (const part of (globalThis.document?.cookie ?? '').split(';')) {
    const [key, ...value] = part.trim().split('=');
    if (key === name) return decodeURIComponent(value.join('='));
  }
  return undefined;
}

export function readCsrfToken(): string | undefined {
  return readCookie(HOST_CSRF_COOKIE) || readCookie(CSRF_COOKIE) || undefined;
}

/** `return_to` stays inside the console: a relative path, never `//host`, a scheme or a backslash. */
export function safeReturnTo(value: string | null | undefined): string {
  if (!value || !value.startsWith('/') || value.startsWith('//') || value.includes('\\')) return '/';
  return value;
}
